import { useCart } from "@/context/CartContext";
import { Link } from "react-router-dom";
import { Plus, Minus, Trash } from "@phosphor-icons/react";

export default function Cart() {
  const { items, update, remove, subtotal } = useCart();
  const shipping = subtotal >= 100 || items.length === 0 ? 0 : 9.90;
  const total = subtotal + shipping;

  return (
    <div>
      <div className="border-b border-zinc-900 px-6 md:px-12 py-8">
        <div className="tag mb-3">Cart</div>
        <h1 className="text-4xl sm:text-5xl font-black tracking-tighter uppercase font-[Outfit]">Your Cart</h1>
      </div>
      {items.length === 0 ? (
        <div className="p-16 text-center">
          <div className="text-2xl font-black uppercase tracking-tighter font-[Outfit]">Nothing Here Yet</div>
          <Link to="/products" className="btn-brutal btn-red mt-6 inline-flex">Browse Products</Link>
        </div>
      ) : (
        <div className="grid grid-cols-1 lg:grid-cols-3 border-b border-zinc-900">
          <div className="lg:col-span-2 border-r border-zinc-900">
            {items.map(i => (
              <div key={i.product_id} className="flex gap-4 p-4 border-b border-zinc-200 last:border-b-0" data-testid={`cart-page-${i.product_id}`}>
                <div className="w-20 h-20 bg-zinc-100 border border-zinc-900 flex-shrink-0">
                  {i.image && <img src={i.image} alt="" className="w-full h-full object-contain p-1" />}
                </div>
                <div className="flex-1">
                  <div className="font-semibold leading-tight">{i.title}</div>
                  <div className="text-sm text-zinc-600 mt-1">${i.price.toFixed(2)} each</div>
                  <div className="flex items-center gap-2 mt-2">
                    <button onClick={() => update(i.product_id, i.quantity - 1)} className="w-8 h-8 border border-zinc-900 flex items-center justify-center hover:bg-zinc-900 hover:text-white"><Minus size={12} weight="bold" /></button>
                    <span className="w-8 text-center font-bold">{i.quantity}</span>
                    <button onClick={() => update(i.product_id, i.quantity + 1)} className="w-8 h-8 border border-zinc-900 flex items-center justify-center hover:bg-zinc-900 hover:text-white"><Plus size={12} weight="bold" /></button>
                    <button onClick={() => remove(i.product_id)} className="ml-3 w-8 h-8 border border-zinc-900 flex items-center justify-center hover:bg-[#ff3333] hover:border-[#ff3333] hover:text-white"><Trash size={12} weight="bold" /></button>
                  </div>
                </div>
                <div className="text-xl font-black font-[Outfit] self-start">${(i.price * i.quantity).toFixed(2)}</div>
              </div>
            ))}
          </div>
          <aside className="p-6 md:p-10 bg-zinc-100">
            <div className="text-xs uppercase tracking-widest font-bold font-[Outfit] mb-4">Summary</div>
            <dl className="space-y-2 text-sm">
              <div className="flex justify-between"><dt>Subtotal</dt><dd>${subtotal.toFixed(2)}</dd></div>
              <div className="flex justify-between"><dt>Shipping</dt><dd>{shipping === 0 ? "FREE" : `$${shipping.toFixed(2)}`}</dd></div>
              <div className="flex justify-between border-t border-zinc-900 pt-3 text-lg font-black font-[Outfit]"><dt>Total</dt><dd>${total.toFixed(2)} NZD</dd></div>
            </dl>
            <Link to="/checkout" data-testid="cart-page-checkout" className="btn-brutal btn-red w-full mt-6">Checkout →</Link>
          </aside>
        </div>
      )}
    </div>
  );
}
